import { DriverStatusName } from "interfaces/domain/driver.interface";

export const isDriverOnDuty = (driverStatus: DriverStatusName) => {
  if (driverStatus === "AVAILABLE" || driverStatus === "UNAVAILABLE") return false;
  return true;
};
